// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App';
import router from './router';
import store from './store';

require('babel-polyfill');

sync(store, router);

Vue.config.productionTip = false;

if (document.documentMode) {
  document.body.classList.add('ie');
} else {
  document.body.classList.add('no-ie');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js